
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmiley2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 29,
  width: 80,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M26.49 0q6.08 1.04 9.08 6.3a.63.62 63.4 0 0 .8.27q3.4-1.5 6.66 0a.73.72-63 0 0 .93-.31Q46.89 1.05 52.97 0h2.58q6.44 1.05 9.26 6.62a.46.46 0 0 0 .53.23l12.72-3.72a.59.59 0 0 1 .73.39l.53 1.82a.45.45 0 0 1-.31.56L66.16 9.66a.47.46-10.9 0 0-.33.48q.58 7.79-5.83 11.55c-8.05 4.72-17.67-1.81-17.15-10.87a1.87 1.86-88.4 0 0-1.86-1.97h-2.33a1.88 1.88 0 0 0-1.88 2c.73 11.24-13.17 16.73-20.43 8.12q-2.94-3.49-2.54-8.8a.49.48 10.3 0 0-.35-.5L.59 5.91a.43.42 16 0 1-.29-.52l.56-1.91a.53.52-73.5 0 1 .65-.36l12.55 3.67a.67.65-66.9 0 0 .75-.31Q17.83 1.13 23.94 0h2.55Zm7.4 11.62a8.67 8.67 0 0 0-8.67-8.67 8.67 8.67 0 0 0-8.67 8.67 8.67 8.67 0 0 0 8.67 8.67 8.67 8.67 0 0 0 8.67-8.67Zm29.06 0a8.68 8.68 0 0 0-8.68-8.68 8.68 8.68 0 0 0-8.68 8.68 8.68 8.68 0 0 0 8.68 8.68 8.68 8.68 0 0 0 8.68-8.68Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M25.23 8.52c1.29 0 6.46 1.15 5.64 3.63a1.35 1.32 27 0 1-2.05.63q-1.88-1.32-3.59-1.32-1.71.01-3.59 1.33a1.35 1.32-27.2 0 1-2.04-.63c-.83-2.47 4.33-3.64 5.63-3.64ZM54.26 11.46q-1.7 0-3.59 1.32a1.35 1.32-27 0 1-2.04-.63c-.82-2.47 4.34-3.63 5.64-3.63 1.29 0 6.45 1.17 5.63 3.64a1.35 1.32 27.2 0 1-2.05.63q-1.88-1.33-3.59-1.33ZM41.34 29h-3.05l-6.74-1.87a1.36 1.2-69.3 0 1-.69-1.82l.02-.05a1.46 1.45 23.8 0 1 1.89-.73q7.22 3.07 14.13-.04a1.37 1.36-20.2 0 1 1.87.86l.14.49a.91.9-21.6 0 1-.46 1.06q-3.11 1.62-7.11 2.1Z"
})));

      const __svgRaw = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\r\n<svg height=\"29\" width=\"80\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0.00 0.00 80.00 29.00\">\r\n<path fill=\"var(--theme-primary, #810ea9)\" d=\"\r\n  M 26.49 0.00\r\n  Q 32.57 1.04 35.57 6.30\r\n  A 0.63 0.62 63.4 0 0 36.37 6.57\r\n  Q 39.77 5.07 43.03 6.57\r\n  A 0.73 0.72 -63.0 0 0 43.96 6.26\r\n  Q 46.89 1.05 52.97 0.00\r\n  L 55.55 0.00\r\n  Q 61.99 1.05 64.81 6.62\r\n  A 0.46 0.46 0.0 0 0 65.34 6.85\r\n  L 78.06 3.13\r\n  A 0.59 0.59 0.0 0 1 78.79 3.52\r\n  L 79.32 5.34\r\n  A 0.45 0.45 0.0 0 1 79.01 5.90\r\n  L 66.16 9.66\r\n  A 0.47 0.46 -10.9 0 0 65.83 10.14\r\n  Q 66.41 17.93 60.00 21.69\r\n  C 51.95 26.41 42.33 19.88 42.85 10.82\r\n  A 1.87 1.86 -88.4 0 0 40.99 8.85\r\n  L 38.66 8.85\r\n  A 1.88 1.88 0.0 0 0 36.78 10.85\r\n  C 37.51 22.09 23.61 27.58 16.35 18.97\r\n  Q 13.41 15.48 13.81 10.17\r\n  A 0.49 0.48 10.3 0 0 13.46 9.67\r\n  L 0.59 5.91\r\n  A 0.43 0.42 16.0 0 1 0.30 5.39\r\n  L 0.86 3.48\r\n  A 0.53 0.52 -73.5 0 1 1.51 3.12\r\n  L 14.06 6.79\r\n  A 0.67 0.65 -66.9 0 0 14.81 6.48\r\n  Q 17.83 1.13 23.94 0.00\r\n  L 26.49 0.00\r\n  Z\r\n  M 33.89 11.62\r\n  A 8.67 8.67 0.0 0 0 25.22 2.95\r\n  A 8.67 8.67 0.0 0 0 16.55 11.62\r\n  A 8.67 8.67 0.0 0 0 25.22 20.29\r\n  A 8.67 8.67 0.0 0 0 33.89 11.62\r\n  Z\r\n  M 62.95 11.62\r\n  A 8.68 8.68 0.0 0 0 54.27 2.94\r\n  A 8.68 8.68 0.0 0 0 45.59 11.62\r\n  A 8.68 8.68 0.0 0 0 54.27 20.30\r\n  A 8.68 8.68 0.0 0 0 62.95 11.62\r\n  Z\"\r\n/>\r\n<path fill=\"var(--theme-primary, #810ea9)\" d=\"\r\n  M 25.23 8.52\r\n  C 26.52 8.52 31.69 9.67 30.87 12.15\r\n  A 1.35 1.32 27.0 0 1 28.82 12.78\r\n  Q 26.94 11.46 25.23 11.46\r\n  Q 23.52 11.47 21.64 12.79\r\n  A 1.35 1.32 -27.2 0 1 19.60 12.16\r\n  C 18.77 9.69 23.93 8.52 25.23 8.52\r\n  Z\"\r\n/>\r\n<path fill=\"var(--theme-primary, #810ea9)\" d=\"\r\n  M 54.26 11.46\r\n  Q 52.56 11.46 50.67 12.78\r\n  A 1.35 1.32 -27.0 0 1 48.63 12.15\r\n  C 47.81 9.68 52.97 8.52 54.27 8.52\r\n  C 55.56 8.52 60.72 9.69 59.90 12.16\r\n  A 1.35 1.32 27.2 0 1 57.85 12.79\r\n  Q 55.97 11.46 54.26 11.46\r\n  Z\"\r\n/>\r\n<path fill=\"var(--theme-primary, #810ea9)\" d=\"\r\n  M 41.34 29.00\r\n  L 38.29 29.00\r\n  L 31.55 27.13\r\n  A 1.36 1.20 -69.3 0 1 30.86 25.31\r\n  L 30.88 25.26\r\n  A 1.46 1.45 23.8 0 1 32.77 24.53\r\n  Q 39.99 27.60 46.90 24.49\r\n  A 1.37 1.36 -20.2 0 1 48.77 25.35\r\n  L 48.91 25.84\r\n  A 0.91 0.90 -21.6 0 1 48.45 26.90\r\n  Q 45.34 28.52 41.34 29.00\r\n  Z\"\r\n/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/smiley2.09bc53e74f50f7747434d3f5a570ed51.svg"),
        {
          React: SvgSmiley2,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      